import {Frontend} from "./frontend";

(function () {
    XonBoard.EnLinkModBusSensorReads = {
        list: {

            selectors: {
                sensor_reads_table: $('#sensor-reads-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.sensor_reads_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.sensor_reads_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsTotal);
                            return json.data;
                        },
                        data(d) {
                            const from_datetime = $('#from_datetime').val();
                            if (from_datetime) {
                                d.from_datetime = from_datetime;
                            }

                            const to_datetime = $('#to_datetime').val();
                            if (to_datetime) {
                                d.to_datetime = to_datetime;
                            }
                        },
                    },
                    columns: [
                        {data: 'received_date', name: 'sensor_reads.received_date', createdCell: self.renderCell,},
                        {
                            data: 'voltage',
                            name: 'sensor_reads.values->voltage',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'power',
                            name: 'sensor_reads.values->power',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'total_installed_rectifiers',
                            name: 'sensor_reads.values->total_installed_rectifiers',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'total_faulty_rectifiers',
                            name: 'sensor_reads.values->total_faulty_rectifiers',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'current_1',
                            name: 'sensor_reads.values->current_1',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'total_energy',
                            name: 'sensor_reads.values->total_energy',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'line_1_voltage',
                            name: 'sensor_reads.values->line_1_voltage',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'line_2_voltage',
                            name: 'sensor_reads.values->line_2_voltage',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'line_3_voltage',
                            name: 'sensor_reads.values->line_3_voltage',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'current_2',
                            name: 'sensor_reads.values->current_2',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'temperature',
                            name: 'sensor_reads.values->temperature',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'state_of_charge',
                            name: 'sensor_reads.values->state_of_charge',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'total_installed_pvc',
                            name: 'sensor_reads.values->total_installed_pvc',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'total_faulty_pvc',
                            name: 'sensor_reads.values->total_faulty_pvc',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'pvc_charge_power',
                            name: 'sensor_reads.values->pvc_charge_power',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'total_pvc_energy',
                            name: 'sensor_reads.values->total_pvc_energy',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'smoke_alarm_mc',
                            name: 'sensor_reads.values->smoke_alarm_mc',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'smoke_alarm_bc',
                            name: 'sensor_reads.values->smoke_alarm_bc',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'fan_alarm_bc',
                            name: 'sensor_reads.values->fan_alarm_bc',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'intrusion_alarm_bc',
                            name: 'sensor_reads.values->intrusion_alarm_bc',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'generator_fault',
                            name: 'sensor_reads.values->generator_fault',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'fan_alarm_rectifier',
                            name: 'sensor_reads.values->fan_alarm_rectifier',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'ext_mains_fail_rectifier',
                            name: 'sensor_reads.values->ext_mains_fail_rectifier',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'temperature_high',
                            name: 'sensor_reads.values->temperature_high',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'site_name',
                            name: 'sensor_reads.values->site_name',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'latitude',
                            name: 'sensor_reads.values->latitude',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {
                            data: 'longitude',
                            name: 'sensor_reads.values->longitude',
                            createdCell: self.renderCell,
                            sortable: false,
                            searchable: false
                        },
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "desc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                        Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
                XonBoard.Utils.Select2.init();
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
            renderCell(td, cellData) {
                if (cellData && cellData.value != null) {
                    $(td).addClass(cellData.class);
                    $(td).html(cellData.value);
                    return;
                }

                $(td).html(cellData);
            }
        },
    }
})();
